import { ConnectWithUsActions } from "./action";

const initialState = {
  ConnectWithUsData: [],
  ContactUsData: [],
};

export const ConnectWithUsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ConnectWithUsActions.SET_CONNEC_WITH_US:
      return {
        ...state,
        ConnectWithUsData: action.payload,
      };
    case ConnectWithUsActions.SET_CONTACT_US_RESPONSE:
      return {
        ...state,
        ContactUsData: action.payload
      }
    default:
      return state;
  }
};
